import { WidgetType } from 'types/widget.types';

/**
 * Widget types that have side menu settings
 *
 * Note: When a widget in this list and the side menu settings are open,
 * click on another widget in this list would maintain the side menu settings state, such as keeping it open
 */
const SIDE_MENU_WIDGET_TYPES = [
  WidgetType.AreaChart,
  WidgetType.BarChart,
  WidgetType.ComboChart,
  WidgetType.ColumnChart,
  WidgetType.HalfPieChart,
  WidgetType.HistogramChart,
  WidgetType.LineChart,
  WidgetType.MapChart,
  WidgetType.PieChart,
  WidgetType.StackedAreaChart,
  WidgetType.StackedBarChart,
  WidgetType.StackedColumnChart,
  WidgetType.FunnelChart,
  WidgetType.ScatterBubbleChart,
  WidgetType.WordCloudChart,
  WidgetType.Image,
  WidgetType.MultipleChoices,
  WidgetType.Form,
];

const CHART_TABLE_MIN_COLS = 15;
const CHART_TABLE_MIN_ROWS = 15;

export { SIDE_MENU_WIDGET_TYPES, CHART_TABLE_MIN_COLS, CHART_TABLE_MIN_ROWS };
